import React from 'react';
import { createRoot } from 'react-dom/client';
import Photorealizm from '../components/Photorealizm';
const projectContainer = document.getElementById('photorealizm-page');

if (projectContainer) {
  const root = createRoot(projectContainer);
  root.render(
    // <React.StrictMode> // Optional, good for development
      <Photorealizm />
    // </React.StrictMode>
  );
} else {
  console.error("Root element for Photorealizm (#photorealizm-page) not found. Check your Rails view.");
}